import { CustomFormats } from "react-intl";
import currencies from "./currencies";
import dates from "./dates";

export function getLang() {
	if (!window.lang) {
		// determine lang from query parameter for dev environment
		const match = window.location.search.match(/lang=([^&]+)/);
		return match ? match[1] : "de-DE";
	} else {
		return window.lang;
	}
}

async function getFallbackMessages(lang: string) {
	switch (lang) {
		case "bg-BG":
			return await import("./bg-BG.json").then((module) => module.default);
		case "cs-CZ":
			return await import("./cs-CZ.json").then((module) => module.default);
		case "de-DE":
			return await import("./de-DE.json").then((module) => module.default);
		case "en-PK":
			return await import("./en-PK.json").then((module) => module.default);
		case "es-ES":
			return await import("./es-ES.json").then((module) => module.default);
		case "fr-FR":
			return await import("./fr-FR.json").then((module) => module.default);
		case "hr-HR":
			return await import("./hr-HR.json").then((module) => module.default);
		case "hu-HU":
			return await import("./hu-HU.json").then((module) => module.default);
		case "it-IT":
			return await import("./it-IT.json").then((module) => module.default);
		case "nl-NL":
			return await import("./nl-NL.json").then((module) => module.default);
		case "pl-PL":
			return await import("./pl-PL.json").then((module) => module.default);
		case "pt-PT":
			return await import("./pt-PT.json").then((module) => module.default);
		case "ro-MD":
			return await import("./ro-MD.json").then((module) => module.default);
		case "ro-RO":
			return await import("./ro-RO.json").then((module) => module.default);
		case "ru-KZ":
			return await import("./ru-KZ.json").then((module) => module.default);
		case "ru-RU":
			return await import("./ru-RU.json").then((module) => module.default);
		case "sk-SK":
			return await import("./sk-SK.json").then((module) => module.default);
		case "sr-RS":
			return await import("./sr-RS.json").then((module) => module.default);
		case "tr-TR":
			return await import("./tr-TR.json").then((module) => module.default);
		case "uk-UA":
			return await import("./uk-UA.json").then((module) => module.default);
		default:
			return await import("./en-US.json").then((module) => module.default);
	}
}

async function getCorrectMessagesOrDefault(lang: string) {
	const langUnderscore = lang.replace("-", "_");
	const correctMessages: Record<PropertyKey, string> =
		typeof window !== "undefined" ? window["translations_ORDERCAPTURE_" + langUnderscore] : undefined;
	if (correctMessages) {
		return correctMessages;
	}
	return getFallbackMessages(lang);
}

const lang = getLang();
const messages = await getCorrectMessagesOrDefault(lang);

export const getMessages = () => messages;

export const getFormats = (): CustomFormats => ({ ...currencies, ...dates });
